import { useState, useEffect, useContext } from 'react'
import { useQlikTicketApi } from '../api/qlikTicket/qlikTicket.api'
import { QlikUIContext } from '../QlikUIContext';

export function useQlikScripts() {

    const [scriptsLoaded, setScriptsLoaded] = useState(false);

    const context = useContext(QlikUIContext);
    const apiQlikTicket = useQlikTicketApi();

    async function loadCapabilityApis() {

      const scriptUrl = `${(context.qlikSecure ? 'https://' : 'http://') + context.qlikEnvironmentUrl + (context.qlikPort ? `:${context.qlikPort}` : '') + context.qlikPrefix}resources/assets/external/requirejs/require.js`;
      const styleUrl = `${(context.qlikSecure ? 'https://' : 'http://') + context.qlikEnvironmentUrl + (context.qlikPort ? `:${context.qlikPort}` : '') + context.qlikPrefix}resources/autogenerated/qlik-styles.css`;
      let existingScript = document.querySelectorAll("script[src='" + scriptUrl + "']");
      let existingStyle = document.querySelectorAll("link[href='" + styleUrl + "']");

      if (existingScript.length == 0
        && existingStyle.length == 0) {

        const capabilityApisJS = document.createElement('script');
        capabilityApisJS.src = scriptUrl; 
        capabilityApisJS.type = 'text/javascript';
        document.head.appendChild(capabilityApisJS);
        capabilityApisJS.loaded = new Promise((resolve) => {
          capabilityApisJS.onload = () => { resolve(); };
        });

        const capabilityApisCSS = document.createElement('link');
        capabilityApisCSS.href = styleUrl; 
        capabilityApisCSS.type = 'text/css';
        capabilityApisCSS.rel = 'stylesheet';
        document.head.appendChild(capabilityApisCSS);
        capabilityApisCSS.loaded = new Promise((resolve) => {
          capabilityApisCSS.onload = () => { resolve(); };
        });

        await Promise.all([capabilityApisJS.loaded, capabilityApisCSS.loaded]);
      }
    }
  
    useEffect(() => {

      async function load() {

        await loadCapabilityApis();

        if (window.require === undefined || window.require === null) {
          const tck = await apiQlikTicket.GetQlikTicket(context.userName, context.qlikEnvironmentUrl);
          global.window.location.href = `${(context.qlikSecure ? 'https://' : 'http://') + context.qlikEnvironmentUrl + (context.qlikPort ? `:${context.qlikPort}` : '') + context.qlikPrefix}content/Default/redir.html?${tck}`;
        }

        setScriptsLoaded(true);
      }

      load();

    }, []);
  
    return [scriptsLoaded];
  }
